export default {
  name: 'marking--remarkP',
  apiService: 'shoes',
  apiPath: '/admin/remark_p',
};